import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-knowledge base_fill",
  "use": "rt-portal-knowledge base_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-knowledge base_fill\">\n<path d=\"M849.2,80H267.7c-73.8,0.1-133.6,58.2-133.6,129.9v606.7c0.1,70.3,58.6,127.2,130.9,127.3h584.3c22.5,0,40.8-17.8,40.8-39.7\n\tV119.6C890,97.8,871.7,80,849.2,80z M544.4,159.4h172.9v224.3c0,6-6.3,9.9-11.6,7.2L638,357.1c-4.5-2.3-9.8-2.3-14.3,0L556,390.9\n\tc-5.3,2.6-11.6-1.3-11.6-7.2V159.4z M808.3,864.6H264.8c-27.2,0-49.2-21.5-49.2-47.9s22-47.9,49.2-47.9h543.5V864.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/knowledge base_fill.svg
// module id = 1272
// module chunks = 116